import { inject, Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberService } from '../services/phone-number.service';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  phoneNumberService = inject(PhoneNumberService);

  transform(value: string | null | undefined): string | null | undefined {
    if (!value) return;
    value = value.trim();
    try {
      return this.phoneNumberService.formatString(value, 'US');
    } catch (e) {
      console.log({ e });
      return value;
    }
  }

}
